<template lang="pug">
section
  h2(style="text-align: center; margin-top: 40px") История
  p(style="text-align:center").
    <span class="text-success">{{ income | formatPrice}}</span> - <span class="text-danger">{{ outcome | formatPrice}}</span> = {{ delta | formatPrice }}
  el-row
    el-col(:span="24")
      datatable(
        ref="datatable"
        :url="'/subjects'"
        :filters="filters"
        :row-class-name="tableRowClassName"
        default-order-by="id"
        default-sort-dir="descending"
        :show-pagination="false"
        @response="onResponse"
        )
        el-table-column(prop="Payment.document", label="Документ", width="120", class-name="document-column")
          template(slot-scope="scope")
            router-link(:to="'/payments/' + scope.row.Payment.id")
              el-tag(:type="tagType(scope.row.Payment)") {{ consts.paymentDocument[scope.row.Payment.document].title.replace(' известие', '') }}
            //- el-tooltip(v-if="scope.row.Payment.status != 2 && scope.row.Payment.overdue > 0", :content="'Просрочено с ' + scope.row.overdue + ' дни'", placement="top", effect="light")
            //-   el-icon.icon-overdue(name="warning")
        el-table-column(prop="Payment.publishedAt", label="От дата", :formatter="dateFormatter", width="100")
        el-table-column(prop="num", label="Фактура №", :formatter="invoiceNumFormatter", width="100")
        el-table-column(prop="Payment.Contragent", label="Контрагент", :formatter="contragentFormatter", :show-overflow-tooltip="true")
        el-table-column(prop="Payment.Company", label="Фирма", :formatter="companyFormatter", width="130")

        el-table-column(prop="quantity", label="Количество", width="120")
        el-table-column(prop="price", label="Цена", :formatter="priceFormatter", width="120")
        el-table-column(prop="discount", label="Отстъпка", width="120")
        el-table-column(prop="priceTotal", label="Крайна цена", :formatter="priceFormatter", width="120")
  el-row
    el-col(:span="24", style="text-align: center; margin-top: 20px")
      el-button(type="primary" @click="exportData") Експорт
</template>

<script>
import Datatable from './Datatable.vue'
import paymentsMixin from '../mixins/paymentsMixin.js'
import * as dateUtil from '../lib/dateUtil'

export default {
  name: 'SubjectHistory',
  mixins: [paymentsMixin],
  props: {
    showContragentName: false,
    filters: {default: {}},
  },
  data () {
    return {
      income: 0,
      outcome: 0,
      delta: 0
    }
  },
  computed: {},
  methods: {
    onResponse (response) {
      this.income = response.data.income
      this.outcome = response.data.outcome
      this.delta = response.data.delta
    },
    tableRowClassName ({row, index}) {
      return row.Payment.type == 1 ? 'text-success' : 'text-danger'
    },
    invoiceNumFormatter (row, column) {
      return this.common.formatInvoiceNum(row.Payment.num)
    },
    contragentFormatter (row, column) {
      if (this.showContragentName) {
        return row.Payment.Contragent.name
      }
      return row.Payment.Contragent.companyName ? row.Payment.Contragent.companyName : row.Payment.Contragent.name
    },
    companyFormatter (row, column) {
      return row.Payment.Company.name.split(' ').slice(0, 2).join(' ')
    },
    dateFormatter (row, column) {
      const date = new Date(row.Payment.publishedAt)
      return dateUtil.format(date, 'DD.MM.YYYY')
    },
    exportData () {
      const params = Object.keys(this.filters).map(f => f + '=' + this.filters[f])
      window.open(`${this.$baseURL}subjects?${params.join('&')}&format=csv&token=${this.$auth.token()}`)
    }
  },
  components: {
    datatable: Datatable
  }
}
</script>

<style lang="stylus">
</style>